module.exports = __webpack_public_path__ + "static/media/logo.bdde2a83.svg";